import { NgModule } from "@angular/core";
import { DatePipe } from "@angular/common";

import { FilterPipe } from "@core/pipes/filter.pipe";

import { InitialsPipe } from "@core/pipes/initials.pipe";

import { SafePipe } from "@core/pipes/safe.pipe";
import { StripHtmlPipe } from "@core/pipes/stripHtml.pipe";
import { CapitalizePipe } from "./capitalize.pipe";
import { TimeLeftPipe } from "./timeLeft.pipe";
import { ColorPipe } from "./color.pipe";
import { TimezonePipe } from "./timeZone.pipe";
import { TextTruncatePipe } from "./truncate.pipe";
import { CurrenciesPipe } from "./currencies.pipe";
import { PointsPipe } from "./points.pipe";
import { DurationPipe } from "./duration.pipe";
import { AvatarUrlPipe } from "./avatarUrl.pipe";
import { FeatherIconPipe } from "./feather-icon.pipe";
import { UtcDatePipe } from "./utc-date.pipe";

@NgModule({
  declarations: [
    InitialsPipe,
    FilterPipe,
    StripHtmlPipe,
    SafePipe,
    CapitalizePipe,
    TimeLeftPipe,
    ColorPipe,
    TimezonePipe,
    TextTruncatePipe,
    CapitalizePipe,
    CurrenciesPipe,
    PointsPipe,
    DurationPipe,
    AvatarUrlPipe,
    FeatherIconPipe,
    UtcDatePipe,
  ],
  imports: [],
  exports: [
    InitialsPipe,
    FilterPipe,
    StripHtmlPipe,
    SafePipe,
    CapitalizePipe,
    TimeLeftPipe,

    ColorPipe,
    TimezonePipe,
    TextTruncatePipe,
    CapitalizePipe,
    CurrenciesPipe,
    PointsPipe,
    DurationPipe,
    AvatarUrlPipe,
    FeatherIconPipe,
    UtcDatePipe,
  ],
  providers: [DatePipe],
})
export class CorePipesModule {}
